import React from 'react';
import Reflux from 'reflux';
import Collapse from 'react-bootstrap/lib/Collapse';
import InfiniteScroll from 'react-infinite-scroller';
import utils from 'utils';
import { Client } from 'api';
import SearchActions from 'actions/SearchActions';
import SearchStore from 'stores/SearchStore';
import { Button, SelectInput } from 'components/forms';
import CityFilter from 'components/VenueSearch/CityFilter';
import CapacityFilter from 'components/VenueSearch/CapacityFilter';
import EventTypeFilter from 'components/VenueSearch/EventTypeFilter';
import VenueTypeFilter from 'components/VenueSearch/VenueTypeFilter';
import OutdoorSpaceFilter from 'components/VenueSearch/OutdoorSpaceFilter';
import InhouseAVFilter from 'components/VenueSearch/InhouseAVFilter';
import CateringRequirementFilter from 'components/VenueSearch/CateringRequirementFilter';
import GuestRoomsFilter from 'components/VenueSearch/GuestRoomsFilter';
import InhouseTablesFilter from 'components/VenueSearch/InhouseTablesFilter';
/* eslint no-unused-vars: 0 */
import css from 'search_results.scss';

export default class extends Reflux.Component {
    static contextTypes = {
        router: React.PropTypes.object,
    };

    coordinates = {};

    constructor(props) {
        super(props);

        const params = this.props.location;

        this.store = SearchStore;
        this.api = new Client();
        this.state = {
            filtersOpen: false,
            regions: [],
            results: [],
            resultCount: 0,
            filters: {
                location: {
                    open: true,
                    value: null,
                    ids: [],
                },
                capacity: {
                    open: params.query.capacity !== undefined,
                    value: params.query.capacity !== undefined ? parseInt(params.query.capacity, 10) : null,
                },
                eventType: {
                    open: params.query.event_type !== undefined,
                    value: params.query.event_type || null,
                },
                venueType: {
                    open: params.query.venue_type !== undefined,
                    value: params.query.venue_type || null,
                },
                outdoorSpace: {
                    open: params.query.outdoor_space !== undefined,
                    value: params.query.outdoor_space !== undefined ? parseInt(params.query.outdoor_space, 10) : null,
                },
                inhouseAV: {
                    open: params.query.inhouse_av !== undefined,
                    value: params.query.inhouse_av !== undefined ? parseInt(params.query.inhouse_av, 10) : null,
                },
                inhouseTables: {
                    open: params.query.inhouse_tables !== undefined,
                    value: params.query.inhouse_tables !== undefined ? parseInt(params.query.inhouse_tables, 10) : null,
                },
                guestRooms: {
                    open: params.query.guest_rooms !== undefined,
                    value: params.query.guest_rooms !== undefined ? parseInt(params.query.guest_rooms, 10) : null,
                },
                catering: {
                    open: params.query.catering !== undefined,
                    value: params.query.catering || null,
                },
            },
        };
    }

    componentWillMount() {
        super.componentWillMount();

        const selectedRegions = this.props.location.query.location.split(',').map(region => parseInt(region, 10));
        const onlyCity = selectedRegions.length === 1;
        const filters = this.state.filters;
        filters.location.ids = [];

        this.api.request(`/api/regions`, {
            method: 'GET',
            success: (regions) => {
                regions.forEach(region => {
                    this.coordinates[region.id] = JSON.parse(region.coordinates);

                    region.checked = false;
                    if (selectedRegions.includes(region.id)) {
                        region.checked = true;
                        filters.location.value = [this.coordinates[region.id]];
                        filters.location.ids.push(region.id);
                    }

                    region.children.forEach(city => {
                        this.coordinates[city.id] = JSON.parse(city.coordinates);
                        city.checked = selectedRegions.includes(region.id) && onlyCity;

                        if (selectedRegions.includes(city.id)) {
                            city.checked = true;
                            filters.location.ids.push(city.id);
                        }

                        city.children.forEach(neighborhood => {
                            this.coordinates[neighborhood.id] = JSON.parse(neighborhood.coordinates);
                            neighborhood.checked = (selectedRegions.includes(region.id) && onlyCity);

                            if (selectedRegions.includes(neighborhood.id)) {
                                neighborhood.checked = true;
                                filters.location.ids.push(neighborhood.id);
                            }
                        });
                    });
                });

                this.setState({ regions: regions, filters: filters }, () => {
                    SearchActions.loadResults(this.state.filters);
                });
            },
        });
    }

    updateFilters = (filters) => {
        this.setState({ filters: filters, page: 0, results: [] }, () => {
            SearchActions.loadResults(this.state.filters);

            if (history.replaceState) {
                const filters = this.state.filters;
                const queries = [`location=${encodeURIComponent(filters.location.ids.join(','))}`];

                if (filters.capacity.value !== null) {
                    queries.push(`capacity=${filters.capacity.value}`);
                }

                if (filters.eventType.value !== null) {
                    queries.push(`event_type=${encodeURIComponent(filters.eventType.value)}`);
                }

                if (filters.venueType.value !== null) {
                    queries.push(`venue_type=${encodeURIComponent(filters.venueType.value)}`);
                }

                if (filters.outdoorSpace.value) {
                    queries.push(`outdoor_space=1`);
                }

                if (filters.inhouseAV.value) {
                    queries.push(`inhouse_av=1`);
                }

                if (filters.inhouseTables.value) {
                    queries.push(`inhouse_tables=1`);
                }

                if (filters.guestRooms.value) {
                    queries.push(`guest_rooms=1`);
                }

                if (filters.catering.value !== null) {
                    queries.push(`catering=${encodeURIComponent(filters.catering.value)}`);
                }

                window.history.replaceState(null, '', `/results?${queries.join('&')}`);
            }
        });
    };

    loadNextPage = () => {
        SearchActions.loadResults(this.state.filters);
    };

    toggleFilters = () => {
        this.setState({ filtersOpen: !this.state.filtersOpen });
    };

    toggleFilter = (filter) => {
        const filters = this.state.filters;
        const status = filters[filter].open;

        if (status === true) {
            filters[filter].open = false;
            filters[filter].value = null;
        } else {
            filters[filter].open = true;
        }

        this.updateFilters(filters);
    };

    changeFilter = (filter, value) => {
        const filters = this.state.filters;
        filters[filter].value = value;

        this.updateFilters(filters);
    };

    cityFilterChanged = (regions) => {
        const coordinates = [];
        const ids = [];
        const filters = this.state.filters;

        regions.filter(region => region.checked === true).forEach(state => {
            const children = state.children.filter(city => city.checked === true);

            ids.push(state.id);
            if (state.all_children === true || children.length === 0) {
                coordinates.push(this.coordinates[state.id]);
                return;
            }

            children.forEach(city => {
                const children = city.children.filter(child => child.checked === true);

                ids.push(city.id);
                if (city.all_children === true || children.length === 0) {
                    coordinates.push(this.coordinates[city.id]);
                    return;
                }

                children.forEach(child => {
                    coordinates.push(this.coordinates[child.id]);
                    ids.push(child.id);
                });
            });
        });

        filters.location.value = coordinates;
        filters.location.ids = ids;
        this.updateFilters(filters);
    };

    clickedVenue = (venue) => {
        window.location.href = `/vendor/${venue.slug}`;
    };

    render() {
        return (
            <div>
                <div className="venue-search-header">
                    <div className="container">
                        Venue Search Results
                    </div>
                </div>

                <div className="venue-search-results container">
                    <Collapse in={this.state.filtersOpen} unmountOnExit={false}>
                        <div className="search-filters">
                            <Button
                                submitLabel="Filter venues"
                                buttonClass="button search-results__open-filters"
                                onClick={this.toggleFilters}
                            />

                            <h2 className="search-filters__header">Filters</h2>

                            <div className="locations-picker">
                                <CityFilter
                                    name="location"
                                    value={this.state.filters.location.value}
                                    open={this.state.filters.location.open}
                                    regions={this.state.regions}
                                    onChange={this.cityFilterChanged}
                                />
                            </div>

                            <CapacityFilter
                                name="capacity"
                                value={this.state.filters.capacity.value}
                                open={this.state.filters.capacity.open}
                                onToggle={this.toggleFilter}
                                onChange={this.changeFilter}
                            />

                            <EventTypeFilter
                                name="eventType"
                                value={this.state.filters.eventType.value}
                                open={this.state.filters.eventType.open}
                                onToggle={this.toggleFilter}
                                onChange={this.changeFilter}
                            />

                            <VenueTypeFilter
                                name="venueType"
                                value={this.state.filters.venueType.value}
                                open={this.state.filters.venueType.open}
                                onToggle={this.toggleFilter}
                                onChange={this.changeFilter}
                            />

                            <OutdoorSpaceFilter
                                name="outdoorSpace"
                                value={this.state.filters.outdoorSpace.value}
                                open={this.state.filters.outdoorSpace.open}
                                onToggle={this.toggleFilter}
                                onChange={this.changeFilter}
                            />

                            <InhouseAVFilter
                                name="inhouseAV"
                                value={this.state.filters.inhouseAV.value}
                                open={this.state.filters.inhouseAV.open}
                                onToggle={this.toggleFilter}
                                onChange={this.changeFilter}
                            />

                            <InhouseTablesFilter
                                name="inhouseTables"
                                value={this.state.filters.inhouseTables.value}
                                open={this.state.filters.inhouseTables.open}
                                onToggle={this.toggleFilter}
                                onChange={this.changeFilter}
                            />

                            <GuestRoomsFilter
                                name="guestRooms"
                                value={this.state.filters.guestRooms.value}
                                open={this.state.filters.guestRooms.open}
                                onToggle={this.toggleFilter}
                                onChange={this.changeFilter}
                            />

                            <CateringRequirementFilter
                                name="catering"
                                value={this.state.filters.catering.value}
                                open={this.state.filters.catering.open}
                                onToggle={this.toggleFilter}
                                onChange={this.changeFilter}
                            />
                        </div>
                    </Collapse>

                    <div className="search-results">
                        <Button
                            submitLabel="Filter venues"
                            buttonClass="button search-results__open-filters"
                            onClick={this.toggleFilters}
                        />

                        <div className="search-results__count">
                            {this.state.resultCount} Results
                        </div>

                        {this.state.results.length === 0 && <div className="search-results__no-results">
                            There are no matching results for your search. To see more results, try adjusting your filters or conducting a new search.
                        </div>}

                        <InfiniteScroll
                            pageStart={this.state.page}
                            hasMore={this.state.page !== this.state.pageCount}
                            loadMore={this.loadNextPage}
                        >
                            {this.state.results.map(result => {
                                return (
                                    <div className="search-result" key={result.vendor_id}>
                                        <div>
                                            {result.vendor_photos.length > 0 &&
                                            <div className="search-result__image" style={{ backgroundImage: `url(${result.vendor_photos[0].medium})` }} onClick={this.clickedVenue.bind(this, result)} />}
                                        </div>

                                        <div className="search-result__details" onClick={this.clickedVenue.bind(this, result)}>
                                            <div className="search-result__name">{result.name}</div>
                                            <div className="search-result__address">{result.address.replace(', USA', '')}</div>


                                            <div className="search-result__body">
                                                <div className="search-result__description">
                                                    <div className="search-result__title">Description</div>
                                                    <div>{result.description.length > 293 ? `${result.description.substr(0, 290)}...` : result.description}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </InfiniteScroll>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./app/assets/javascripts/views/SearchResults.jsx